var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable react/jsx-no-bind */
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import Icon from '../icons/components/Icon';
import { IconCheck, IconCopy } from '../icons/svg';
import { withPixelLineHeight } from '../styles/functions.web';
import { copyText } from '../util/helpers';
const styles = (theme) => {
    return {
        copyButton: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.bodyLongRegular)), { borderRadius: theme.shape.borderRadius, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 8px 8px 16px', marginTop: 5, width: 'calc(100% - 24px)', height: 24, background: theme.palette.action01, cursor: 'pointer', '&:hover': {
                backgroundColor: theme.palette.action01Hover,
                fontWeight: 600
            }, '&.clicked': {
                background: theme.palette.success02
            }, '& > div > svg > path': {
                fill: theme.palette.text01
            } }),
        content: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 292,
            marginRight: theme.spacing(3),
            '&.selected': {
                fontWeight: 600
            }
        }
    };
};
let mounted;
/**
 * Component meant to enable users to copy the conference URL.
 *
 * @returns {React$Element<any>}
 */
function CopyButton({ classes, className, displayedText, textToCopy, textOnHover, textOnCopySuccess, id }) {
    const [isClicked, setIsClicked] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(() => {
        mounted = true;
        return () => {
            mounted = false;
        };
    }, []);
    /**
     * Click handler for the element.
     *
     * @returns {void}
     */
    function onClick() {
        return __awaiter(this, void 0, void 0, function* () {
            setIsHovered(false);
            const isCopied = yield copyText(textToCopy);
            if (isCopied) {
                setIsClicked(true);
                setTimeout(() => {
                    // avoid: Can't perform a React state update on an unmounted component
                    if (mounted) {
                        setIsClicked(false);
                    }
                }, 2500);
            }
        });
    }
    /**
     * Hover handler for the element.
     *
     * @returns {void}
     */
    function onHoverIn() {
        if (!isClicked) {
            setIsHovered(true);
        }
    }
    /**
     * Hover handler for the element.
     *
     * @returns {void}
     */
    function onHoverOut() {
        setIsHovered(false);
    }
    /**
     * KeyPress handler for accessibility.
     *
     * @param {React.KeyboardEventHandler<HTMLDivElement>} e - The key event to handle.
     *
     * @returns {void}
     */
    function onKeyPress(e) {
        if (onClick && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            onClick();
        }
    }
    /**
     * Renders the content of the link based on the state.
     *
     * @returns {React$Element<any>}
     */
    function renderContent() {
        if (isClicked) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: clsx(classes.content, 'selected') },
                    React.createElement("span", { role: 'alert' }, textOnCopySuccess)),
                React.createElement(Icon, { src: IconCheck })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: clsx(classes.content) },
                React.createElement("span", null,
                    " ",
                    isHovered ? textOnHover : displayedText,
                    " ")),
            React.createElement(Icon, { src: IconCopy })));
    }
    return (React.createElement("div", { "aria-label": textOnHover, className: clsx(className, classes.copyButton, isClicked ? ' clicked' : ''), id: id, onBlur: onHoverOut, onClick: onClick, onFocus: onHoverIn, onKeyPress: onKeyPress, onMouseOut: onHoverOut, onMouseOver: onHoverIn, role: 'button', tabIndex: 0 }, renderContent()));
}
CopyButton.defaultProps = {
    className: ''
};
// @ts-ignore
export default withStyles(styles)(CopyButton);
